import React, { useEffect, useState } from "react";
import PackageDetailsSection from "../../Components/PackageDetailsSections/PackageDetailsSection";
import PageTitle from "../../Components/UI/PageTitle";
import CoursesInPackage from "../../Components/PackageDetailsSections/CoursesInPackage";
import PackageEnrollmentSection from "../../Components/PackageDetailsSections/PackageEnrollmentSection";
import LightButton from "../../Components/UI/LightButton";
import { useParams } from "react-router-dom";
import { getPackageDetails } from "../../apis";
import { transformKeys } from "../../_helper";
import Loader from "../../Components/Loader";
import ErrorAnimationComponent from "../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";

const PackageDetails = () => {
  const { packageManagementId, packageId } = useParams();
  const [packageDetailsData, setPackageDetailsData] = useState([]);
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getPackageDetails(packageId)
      .then((data) => {
        setPackageDetailsData(data.data.data);
      })
      .catch((error) => {
        setIsError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [packageId]);

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;

  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          { title: "Package Management", link: "/package-management" },
          {
            title: "Packages List",
            link: `/package-management/${packageManagementId}?filterBy=partner_type`,
          },
          { title: "Package Details" },
        ]}
      />
      <div className="tw-flex max-md:tw-flex-col max-md:tw-gap-4 justify-content-between tw-items-center tw-mb-6">
        <h2 className="h4 !tw-m-0">Package Details</h2>
        <LightButton
          hoverColor="hover:tw-text-blueLight"
          text={"Edit In Package"}
          icon={<span className="material-icons tw-me-2">edit</span>}
          to={`/package-management/${packageManagementId}/package-details/${packageId}/update-package`}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <PackageDetailsSection
          title="Package Data"
          data={transformKeys(packageDetailsData?.packageData || {})}
        />
        <CoursesInPackage
          coursesData={packageDetailsData?.courses?.courseData || []}
          totalPrice={packageDetailsData?.courses?.["totalE-money"] || 0}
          totalPvDirect={packageDetailsData?.courses?.totalPvDirect || 0}
          registrationPrice={packageDetailsData?.packageData?.registrationPrice}
        />

        <PackageEnrollmentSection
          title={"Package Enrollment"}
          packageEnrollment={packageDetailsData?.packageEnrollment || {}}
        />
      </div>
    </>
  );
};

export default PackageDetails;
